import { sharedData } from '../../../models/shared_data'
import React from 'react'
import { LoginButton } from '../login_button.component'

export class ProfileButton extends React.Component {
  constructor(props) {
    super(props)
    this.isActive = this.isActive.bind(this)
    sharedData.subject
      .subscribe(()=> {
        this.forceUpdate()
      })
  }

  isActive() {
    return ''
  }
  render() {
    if(sharedData.data.client) {
      return (
        <a href="/profile" className={this.isActive()}>
          Личный кабинет
        </a>
      )
    } else {
      return (
        <LoginButton></LoginButton>
      )
    }



  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/profile/profile_button/profile_button.component.js